// removed by extract-text-webpack-plugin
module.exports = {"container":"partials-social-buttons-container","item":"partials-social-buttons-item","circle":"partials-social-buttons-circle","icon":"partials-social-buttons-icon","facebook":"partials-social-buttons-facebook","twitter":"partials-social-buttons-twitter"};


//////////////////
// WEBPACK FOOTER
// ./styles/partials/social-buttons.scss
// module id = 877
// module chunks = 246